export default class AbstractInterpreter {
  get context() {
    return {};
  }

  reset() {}
}
